import Swiper from "swiper";

$(document).ready(function ($) {
    new Swiper(".hero-slider", {
        loop: false,
        slidesPerView: 1,
        centeredSlides: false,
        responsive: true,
        autoHeight: true,
        simulateTouch: $('.neos-backend').length ? false : true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});